import { decodeTokenScopes } from "../../auth/accessToken/helpers";
import useAuth from "../../auth/accessToken/hooks/useAuth";
import useScopes from "../../auth/accessToken/hooks/useScopes";

const useHasAnyOfScopes = (selectedScopes: string[]) => {
    const scopes = useScopes();
    return !!selectedScopes.find((s) => scopes.includes(s));
};

/**
 * Same check, but for the token of a specific account instead of the account in
 * the URL — e.g. the root admin's own scopes while inspecting another account,
 * where `state.tokens` holds the inspected account and the partner tokens have
 * been moved to `partner_user`.
 */
export const useHasAnyOfScopesForAccount = (
    accountId: string | undefined,
    selectedScopes: string[],
) =>
    useAuth((state) => {
        if (!accountId) {
            return false;
        }
        const token =
            state.tokens[accountId] ?? state.partner_user?.tokens?.[accountId];
        const scopes = decodeTokenScopes(token);
        return selectedScopes.some((scope) => scopes.includes(scope));
    });

export default useHasAnyOfScopes;
